import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Services } from './../services-url';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {

  constructor(
    private http: HttpClient,
  ) { }


  getDocuments():Observable<any>{
    return this.http.get(Services.documents).pipe(
      tap(documents => console.info(`fetched documents`))
    )
  }

  getCategories():Observable<any>{
    return this.http.get(Services.documentsCategories).pipe(
      tap(documents => console.info(`fetched categories documents`))
    );
  }

  search(departament,municipality,category,keyword):Observable<any>{

    let url = `${Services.searchDocument}/${departament}/${municipality}/${category}/${keyword}`

    return this.http.get(url).pipe(
      tap(documents => console.info(`fetched documents filtered`))
    );
  }
}
